import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SharedCallingExtension, ZiroDraasExtensions } from '../../../shared/models/generated/ziroModels';

@Injectable()
export class DraasSharedExtensionsResource {
  private http = inject(HttpClient);

  getAllExtensions(tenantId: string | number, e164: string): Observable<ZiroDraasExtensions> {
    return this.http.get<ZiroDraasExtensions>(
      `/services/microsoft/macs/tenants/${tenantId}/ziro-draas-numbers/${encodeURIComponent(e164)}`,
    );
  }

  getExtension(tenantId: string | number, e164: string, extension: string): Observable<SharedCallingExtension> {
    return this.http.get<SharedCallingExtension>(
      `/services/microsoft/macs/tenants/${tenantId}/ziro-draas-numbers/${encodeURIComponent(e164)}/shared-extensions/${encodeURIComponent(
        extension,
      )}`,
    );
  }

  postExtension(
    tenantId: string | number,
    e164: string,
    request: { sharedCallingExtension: string },
  ): Observable<void> {
    return this.http.post<void>(
      `/services/microsoft/macs/tenants/${tenantId}/ziro-draas-numbers/${encodeURIComponent(e164)}/shared-extensions`,
      request,
    );
  }

  deleteExtension(tenantId: string | number, e164: string, extension: string): Observable<void> {
    return this.http.delete<void>(
      `/services/microsoft/macs/tenants/${tenantId}/ziro-draas-numbers/${encodeURIComponent(e164)}/shared-extensions/${encodeURIComponent(
        extension,
      )}`,
    );
  }
}
